// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3GbP9","inputWrap":"CustomTip_inputWrap__2FThI"};